import { ReactElement, useCallback } from 'react';

import QuerySelect from '@/common/QuerySelect';
import Select from '@/common/Select';
import { SelectTypes } from '@/common/Select/types';
import { queryInput } from '@/utils';
import searchGroups from '@/api/services/groups/searchGroups';

export type SelectEvaluatorGroupsProps = Omit<SelectTypes.Props, 'children' | 'ref' | 'value' | 'onChange' | 'multiple'> & {
  value?: string[];
  onChange?: (value: string[]) => void;
};

const SelectEvaluatorGroups = ({
  value = [],
  onChange,
  placeholder = 'All Evaluators',
  ...props
}: SelectEvaluatorGroupsProps): ReactElement => {
  const getOptions = useCallback(async () => {
    const { rows } = await searchGroups([{ active: queryInput(1) }]);
    return (rows || [])
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((group) => (
        <Select.Option id={group.id} value={group.id} key={group.id}>
          {group.name}
        </Select.Option>
      ));
  }, []);

  const handleChange = (selected: SelectTypes.ValueProp): void => {
    const id = String(selected);
    onChange?.(value.includes(id) ? value.filter((groupId) => groupId !== id) : [...value, id]);
  };

  return <QuerySelect {...props} multiple placeholder={placeholder} value={value} onChange={handleChange} query={getOptions} />;
};

export default SelectEvaluatorGroups;
